import { schema } from 'normalizr';
import assetSchema from './asset_schema';

const findingSchema = new schema.Entity('entryfindings', {
  assets: [assetSchema],
});

export default findingSchema;
